import React from "react";
import { SUB_DIRCTORY } from "../../../app_config";
import { authRoles } from "../../auth/authRoles";

const dashboardRoutes = [
  {
    path: `${SUB_DIRCTORY}/dashboard`,
    component: React.lazy(() => import("./Chart")),
    auth: authRoles.admin
  }
];

export default dashboardRoutes;
